<template>
  <div class="app-footer" style="background-color: #b50a2b">
    <div class="footer-content">
      <div class="footer-info" style="color: #ffffff">
        <p>浙江省杭州市西湖区留和路288号（浙江工业大学屏峰校区 仁和楼 317)</p>
        <p>0571-85290398（招生）0571-85290255（教务）0571-85290796（培养）邮箱：mpa@zjut.edu.cn</p>
      </div>
      <div>
        <img src="@/assets/images/weixin.png" class="network_img" />
        <p style="color: #ffffff">浙江工业大学MPA教育中心</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variable.scss';
.app-footer {
  background: $footer_color;
  color: #666;
  font-size: 12px;
  text-align: center;
  height: 132px;
  .footer-content {
    width: $container_width;
    height: 132px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .network_img {
      width: 90px;
      height: 90px;
    }
    p {
      text-align: left;
      margin-bottom: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue